import './App.css';
import Router from './routes'

function App() {

  return (
    <div className="App d-flex">
      <Router />
    </div>
  );
}

export default App;
